import { Component, Injector, OnInit } from "@angular/core";
import { BaseEntityComponent, BaseEntityConfig, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_AGENTE_ENVIO } from 'src/app/constantes/permissao.constants';
import { InformeRecuperacaoCredito, LoteRecuperacoesCreditoEnvio, RecuperacaoCredito } from 'src/app/model/recuperacao-credito.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { DataSistemaService } from "src/app/shared/services/data-sistema.service";
import { RemoverAlertasService } from "../../../shared/services/remover-alertas.service";
import { RecuperacaoCreditoService } from "../recuperacao-credito/recuperacao-credito.service";

@Component({
    selector: 'app-recuperacao-credito-cadastro',
    templateUrl: './recuperacao-credito-cadastro.component.html',
    styleUrls: ['./recuperacao-credito-cadastro.component.scss'],
    standalone: false
})
export class RecuperacaoCreditoCadastroComponent extends BaseEntityComponent<RecuperacaoCredito> implements OnInit {

    public recuperacoes: RecuperacaoCredito[];
    public cnpjAgente: string;
    public modoEdicao: boolean = true;
    public podeEnviarRecCredito: boolean;
    private dataCorrente: Date;

    constructor(protected injector: Injector,
        protected service: RecuperacaoCreditoService,
        private bnUsuarioService: BnUsuarioService,
        private removerAlertasService: RemoverAlertasService,
        private permissaoService: PermissaoService,
        private dataSistemService: DataSistemaService
        ) {
        super(service, new BaseEntityConfig('/recuperacoes-credito/cadastro'));
        this.config.rotaLista = '/recuperacoes-credito/pesquisa';
        dataSistemService.getDataCorrente().subscribe(data => this.dataCorrente = data);
    }

    ngOnInit() {
        this.bnUsuarioService.usuario$.subscribe(usuario => {
            this.cnpjAgente = usuario && usuario.cnpj;
          });

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.podeEnviarRecCredito = resp && resp[ROLE_AGENTE_ENVIO];
            if (!this.podeEnviarRecCredito) {
                let mensagem = 'Usuário sem permissão para realizar esta ação';
                this.messageService.addMessage({
                    title: 'Erro',
                    type: 'CRUD_OPERATION',
                    level: messageLevel.ERROR,
                    message: mensagem
                  });
            }
          });
    }

    inclui() {
        if (!this.modoEdicao) {
            this.modoEdicao = true;
            this.recuperacoes = undefined;
            this.removerAlertasService.removerTodos();
        }

        if (this.recuperacoes == undefined) {
            this.recuperacoes = [];
        }

        this.recuperacoes.push(new RecuperacaoCredito());
    }

    atribuiSistema(recuperacao: RecuperacaoCredito, sistema: string) {
        if (sistema == 'CL') {
            sistema = undefined;
        }
        recuperacao.sistemaRepasse = sistema;
    }

    remove(recuperacao: RecuperacaoCredito) {
        const pos = this.recuperacoes.indexOf(recuperacao);
        this.recuperacoes.splice(pos, 1);
    }

    insereSeNaoExiste(vetorStr: string[], str: string) {
        if (vetorStr.indexOf(str) == -1) {
            vetorStr.push(str);
        }
    }

    executarValidacoesPreliminares(erros?: string[]): boolean {
        let result: boolean = true;
        for (let recuperacao of this.recuperacoes) {
            if (recuperacao.sistemaRepasse) {
                if (!recuperacao.contratoRepasse) {
                    if (erros) {
                        this.insereSeNaoExiste(erros, 'Contrato vazio');
                    }
                    result = false;
                }
            }
            else {
                if(recuperacao.idOperacaoExterno && !recuperacao.idOperacaoExterno.match(/^[A-Za-z0-9_\-]{1,20}$/)){
                    
                    if (erros) {
                        this.insereSeNaoExiste(erros, 'Id. externo deve ter no mínimo 1 e no máximo 20 caracteres');
                    }
                    result = false;
                }
                if (!recuperacao.idOperacaoExterno) {
                    if (erros) {
                        this.insereSeNaoExiste(erros, 'Id. externo operação vazio');
                    }
                    result = false;
                }
            }
            if(!this.validaCampoDataRecuperacao(recuperacao.dataRecuperacao)){
                if (erros) {
                    this.insereSeNaoExiste(erros, 'Data da recuperação preenchida incorretamente');
                }
                result = false;
            }
            if (!recuperacao.dataRecuperacao) {
                if (erros) {
                    this.insereSeNaoExiste(erros, 'Data da recuperação vazia');
                }
                result = false;
            }
            else {
                console.log("verificando se a data da recuperacao eh maior que esta data corrente: " + this.dataCorrente)
                if (recuperacao.dataRecuperacao > this.dataCorrente) {
                    if (erros) {
                        this.insereSeNaoExiste(erros, 'Data da recuperação futura');
                    }
                    result = false;
                }
            }
            if (!recuperacao.valorRecuperacao) {
                if (erros) {
                    this.insereSeNaoExiste(erros, 'Valor da recuperação vazio');
                }
                result = false;
            }
        }
        return result;
    }

    validaCampoDataRecuperacao(dataRecuperacao: Date): boolean{
        return dataRecuperacao instanceof Date && !isNaN(dataRecuperacao.valueOf());
    }

    validar() {
        let erros: string[] = [];
        if (!this.executarValidacoesPreliminares(erros)) {
            for (let erro of erros) {
                this.messageService.addMessage({
                    title: 'Erro',
                    type: 'CRUD_OPERATION',
                    level: messageLevel.ERROR,
                    message: erro
                  });
            }
            return;
        }
        this.salvarOuValidar(true);
    }

    salvar() {
        this.salvarOuValidar(false);
    }

    salvarOuValidar(apenasValidar: boolean) {
        let informesRecuperacaoCredito: InformeRecuperacaoCredito[] = [];

        for (let recuperacao of this.recuperacoes) {
            let informeRecuperacaoCredito = new InformeRecuperacaoCredito();
            if (!recuperacao.sistemaRepasse) {
                informeRecuperacaoCredito.idOperacaoAgenteCreditoLivre = recuperacao.idOperacaoExterno;
            }
            if (recuperacao.sistemaRepasse == '15' || recuperacao.sistemaRepasse == '89') {
                informeRecuperacaoCredito.sistemaRepasse = recuperacao.sistemaRepasse;
                informeRecuperacaoCredito.contratoRepasse = recuperacao.contratoRepasse;
            }
            informeRecuperacaoCredito.recuperacoesCredito = [{
                dataRecuperacao: recuperacao.dataRecuperacao,
                valorRecuperacao: recuperacao.valorRecuperacao,
                saldoLiquidado: recuperacao.saldoLiquidado ? "S" : "N"
            }];
            informesRecuperacaoCredito.push(informeRecuperacaoCredito);
        }

        let json: LoteRecuperacoesCreditoEnvio = {
            cnpjAgenteFinanceiro: this.cnpjAgente,
            informesRecuperacaoCredito: informesRecuperacaoCredito
        }

        this.service.protocolar(json, apenasValidar).subscribe((resp) => {
            console.log(resp);
            if (!resp || !resp.ocorrencias || resp.ocorrencias.length > 0) {
                if (Array.isArray(resp)) {
                    for (let respI of resp) {
                        this.messageService.addMessage({
                            title: 'Erro',
                            type: 'CRUD_OPERATION',
                            level: messageLevel.ERROR,
                            message: respI.mensagem
                        });
                    }
                }
                else {
                    let mensagem: string;
                    if (apenasValidar) {
                        mensagem = 'Ocorreu um erro inesperado na validação.';
                    }
                    else {
                        mensagem = 'Ocorreu um erro inesperado na gravação.';
                    }
                    this.messageService.addMessage({
                        title: 'Erro',
                        type: 'CRUD_OPERATION',
                        level: messageLevel.ERROR,
                        message: mensagem
                    });
                }
            }
            else {
                let mensagem: string;
                if (apenasValidar) {
                    mensagem = 'Recuperação de crédito validada com sucesso.';
                }
                else {
                    this.modoEdicao = false;
                    mensagem = 'Recuperação de crédito gravada com sucesso.';
                }
                this.messageService.addMessage({
                    title: 'Sucesso',
                    type: 'CRUD_OPERATION',
                    level: messageLevel.SUCCESS,
                    message: mensagem
                  });
            }
        });
    }

}